export default __webpack_public_path__ + "static/media/logo_v2.1dc5f408.svg";